export function stripResponseTags(text) {
  return typeof text === 'string' ? text.replace(/<\/?response>/gi, '').trim() : text;
}

export function stabilizeMarkdown(s = '') {
  if (!s || typeof s !== 'string') return '';
  let out = s;
  
  out = out.replace(/\r\n/g, '\n');
  
  const boldCount = (out.match(/\*\*/g) || []).length;
  const italicCount = (out.match(/\*/g) || []).length;
  
  if (boldCount % 2 === 1) out += '**';
  if (italicCount % 2 === 1) out += '*';
  
  return out;
}

export function normalizeUrlKey(raw) {
  try {
    const url = raw?.startsWith('http') ? new URL(raw) : new URL(`https://${raw}`);
    const host = (url.hostname || '').toLowerCase().replace(/^www\./, '');
    let path = url.pathname || '/';
    if (path !== '/') path = path.replace(/\/+$/, '');
    return `${host}${path || '/'}`;
  } catch {
    return (raw || '').trim().toLowerCase();
  }
}

export function dedupeCitations(arr) {
  if (!Array.isArray(arr)) return [];
  const seen = new Set();
  const out = [];
  for (const c of arr) {
    const url = c?.url || c?.href;
    if (!url) continue;
    const key = normalizeUrlKey(url);
    if (seen.has(key)) continue;
    seen.add(key);
    out.push({
      title: c?.title || url,
      url: url.startsWith('http') ? url : `https://${url}`
    });
  }
  return out;
}